import React from 'react';

// Icons
import {
  FiHome, FiGrid,
} from 'react-icons/fi';

const INITIAL_STATE = {
  activeMenu: {
    name: 'Dashboard',
    icon: <FiHome />,
    path: '/',
  },
  itens: [
    {
      name: 'Dashboard',
      icon: <FiHome />,
      path: '/',
    },
    {
      name: 'Perfis de acesso',
      icon: <FiGrid />,
      path: '/perfis',
    },
    {
      name: 'Cargos',
      icon: <FiGrid />,
      path: '/cargos',
    },
    {
      name: 'Documentos',
      icon: <FiGrid />,
      path: '/documentos',
    },
    {
      name: 'Termos de Doação',
      icon: <FiGrid />,
      path: '/termos',
    },
    {
      name: 'Termos de Outorga',
      icon: <FiGrid />,
      path: '/termos',
    },
    {
      name: 'Arquivos',
      icon: <FiGrid />,
      path: '/arquivos',
    },
    {
      name: 'Relatorios',
      icon: <FiGrid />,
      path: '/relatorios',
    },
    {
      name: 'Publicações',
      icon: <FiGrid />,
      path: '/publicacoes',
    },
    {
      name: 'Usuários',
      icon: <FiGrid />,
      path: '/usuarios',
    },
    {
      name: 'Área de pesquisa',
      icon: <FiGrid />,
      path: '/areas',
    },
    {
      name: 'Instituição de pesquisa',
      icon: <FiGrid />,
      path: '/instituicoes',
    },
    {
      name: 'Pesquisadores',
      icon: <FiGrid />,
      path: '/pesquisadores',
    },
    {
      name: 'Avaliadores',
      icon: <FiGrid />,
      path: '/avaliadores',
    },
    {
        name: 'Bolsas',
        icon: <FiGrid />,
        path: '/bolsas',
      },
    {
      name: 'Programas',
      icon: <FiGrid />,
      path: '/programas',
    },
    {
      name: 'Avaliações',
      icon: <FiGrid />,
      path: '/avaliacoes',
    },
    {
      name: 'Projetos em Edição',
      icon: <FiGrid />,
      path: '/edicao',
    },
    {
      name: 'Submetidos',
      icon: <FiGrid />,
      path: '/submetidos',
    },
    {
      name: 'Prestação de contas',
      icon: <FiGrid />,
      path: '/projetos/prestacao-contas',
    },
    {
      name: 'Atividades',
      icon: <FiGrid />,
      path: '/atividades',
    },
    {
      name: 'Solicitações',
      icon: <FiGrid />,
      path: '/solicitacoes',
    },
    {
      name: 'Fale Conosco',
      icon: <FiGrid />,
      path: '/atendimentos',
    },
    {
      name: 'Institucional',
      icon: <FiGrid />,
      path: '/institucional',
    },
  ],
};

export default function sidebarMenu(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_MENU_ACTIVE':
      return { ...state, activeMenu: action.menu };
      break;
    case 'SET_MENU_ITEM':
      return { ...state, itens: action.itens };
      break;
    default:
      return state;
      break;
  }
}
